// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGalleryFooter__container-dd245b {
  --preview-items-padding: 4px;
  box-sizing: border-box;
  display: flex;
  gap: var(--preview-items-padding);
  height: 64px;
  padding: var(--preview-items-padding) 0;
}

.MediaGalleryFooter__preview-block-wrapper-ba3453 {
  position: relative;
  flex: 1;
  height: 100%;
}

.MediaGalleryFooter__preview-block-a19097 {
  position: absolute;
  display: flex;
  gap: var(--preview-items-padding);
  height: 100%;
  width: 100%;
  justify-content: flex-end;
}

.MediaGalleryFooter__preview-block-wrapper-ba3453:last-child .MediaGalleryFooter__preview-block-a19097 {
  justify-content: start;
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaGallery/MediaGalleryFooter/MediaGalleryFooter.styles.m.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EAEA,sBAAA;EACA,aAAA;EACA,iCAAA;EACA,YAAA;EACA,uCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,OAAA;EACA,YAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,iCAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF","sourcesContent":[".container {\n  --preview-items-padding: 4px;\n\n  box-sizing: border-box;\n  display: flex;\n  gap: var(--preview-items-padding);\n  height: 64px;\n  padding: var(--preview-items-padding) 0;\n}\n\n.preview-block-wrapper {\n  position: relative;\n  flex: 1;\n  height: 100%;\n}\n\n.preview-block {\n  position: absolute;\n  display: flex;\n  gap: var(--preview-items-padding);\n  height: 100%;\n  width: 100%;\n  justify-content: flex-end;\n}\n\n.preview-block-wrapper:last-child .preview-block {\n  justify-content: start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaGalleryFooter__container-dd245b`,
	"preview-block-wrapper": `MediaGalleryFooter__preview-block-wrapper-ba3453`,
	"previewBlockWrapper": `MediaGalleryFooter__preview-block-wrapper-ba3453`,
	"preview-block": `MediaGalleryFooter__preview-block-a19097`,
	"previewBlock": `MediaGalleryFooter__preview-block-a19097`
};
module.exports = ___CSS_LOADER_EXPORT___;
